import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ workOrder: string }>;

export const DispatchWorkOrder: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/WorkOrder",
        workOrder: props.parameter.workOrder,
    });
};

export const chain = [DispatchWorkOrder];

const setWorkOrder = createHandlerChainRunner(chain, "WorkOrder");
export default setWorkOrder;
